// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a9980c6","952":"4e387449"}[chunkId] + ".chunk.js";
};